import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine, Cell } from 'recharts';

// Generate bell-curve-like data for Monte Carlo
const generateData = () => {
  const data = [];
  const mean = 255;
  const stdDev = 18;
  for (let i = 210; i <= 300; i += 5) {
    const z = (i - mean) / stdDev;
    const freq = Math.round(1000 * Math.exp(-0.5 * z * z));
    data.push({ dias: i, frequencia: freq, label: `${i}d` });
  }
  return data;
};

const data = generateData();
const p50 = 250;
const p80 = 270;

const MonteCarloHistogram: React.FC = () => (
  <div className="w-full">
    <div className="h-[220px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
          <XAxis dataKey="label" tick={{ fontSize: 10, fill: 'hsl(220 10% 50%)' }} tickLine={false} axisLine={false} />
          <YAxis hide />
          <Tooltip
            contentStyle={{
              backgroundColor: 'hsl(var(--card))',
              border: '1px solid hsl(var(--border))',
              borderRadius: '8px',
              fontSize: '12px',
            }}
            formatter={(v: number) => [`${v} iterações`, 'Frequência']}
            labelFormatter={(l) => `Prazo: ${l}`}
          />
          <ReferenceLine x="250d" stroke="hsl(168, 56%, 50%)" strokeDasharray="4 4" label={{ value: 'P50', position: 'top', fontSize: 11, fill: 'hsl(168, 56%, 50%)' }} />
          <ReferenceLine x="270d" stroke="hsl(168, 56%, 42%)" strokeDasharray="4 4" label={{ value: 'P80', position: 'top', fontSize: 11, fill: 'hsl(168, 56%, 42%)' }} />
          <Bar dataKey="frequencia" radius={[3, 3, 0, 0]} maxBarSize={24}>
            {data.map((entry, index) => (
              <Cell
                key={index}
                fill={entry.dias <= p50 ? 'hsl(168, 56%, 50%)' : entry.dias <= p80 ? 'hsl(168, 56%, 42%)' : 'hsl(0, 70%, 50%)'}
                opacity={0.85}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
    <div className="flex justify-center gap-4 mt-2 text-xs text-muted-foreground">
      <span className="flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-success inline-block" /> ≤ P50</span>
      <span className="flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-primary inline-block" /> P50–P80</span>
      <span className="flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-destructive inline-block" /> &gt; P80</span>
    </div>
  </div>
);

export default MonteCarloHistogram;
